import { z } from 'zod';

// Re-using patterns from the project
export const emailSchema = z
  .string()
  .min(1, 'Email is required')
  .email('Please enter a valid email address');

export const organizationNameSchema = z
  .string()
  .min(1, 'Organization name is required')
  .min(2, 'Name must be at least 2 characters')
  .max(100, 'Name must be less than 100 characters');

export const domainSchema = z
  .string()
  .regex(
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i,
    'Please enter a valid domain name (e.g., example.com)'
  )
  .optional()
  .or(z.literal(''));

export const roleSchema = z.enum(['owner', 'admin', 'member']);

export const createOrganizationSchema = z.object({
  name: organizationNameSchema,
  domain: domainSchema,
  jit_enabled: z.boolean().optional(),
});

export const updateOrganizationSchema = z.object({
  name: organizationNameSchema.optional(),
  domain: domainSchema,
  avatar_url: z.string().url('Please enter a valid URL').optional().or(z.literal('')),
  jit_enabled: z.boolean().optional(),
});

export const inviteMemberSchema = z.object({
  email: emailSchema,
  role: z.enum(['admin', 'member']),
});

export const updateMemberRoleSchema = z.object({
  role: z.enum(['admin', 'member']),
});

export type CreateOrganizationFormData = z.infer<typeof createOrganizationSchema>;
export type UpdateOrganizationFormData = z.infer<typeof updateOrganizationSchema>;
export type InviteMemberFormData = z.infer<typeof inviteMemberSchema>;
export type UpdateMemberRoleFormData = z.infer<typeof updateMemberRoleSchema>;
